__turbopack_context__.v({
  "animatedTextContainer": "AnimateText-module-scss-module__3qZ7uG__animatedTextContainer",
  "maskedLine": "AnimateText-module-scss-module__3qZ7uG__maskedLine",
  "sentinel": "AnimateText-module-scss-module__3qZ7uG__sentinel",
  "srOnly": "AnimateText-module-scss-module__3qZ7uG__srOnly",
});
